import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const StoreSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default StoreSVG;
